import { Fancybox } from '@fancyapps/ui/dist/fancybox/';

// Gravity Forms "Price Range" select: the Section 8 choice's value reads
// "Sorry, we do not offer low-income or Section 8 housing", so match on that.
const SECTION8_PATTERN = /section 8/i;
const POPUP_ID = 'section8-notice';

function getPopup() {
  let popup = document.getElementById(POPUP_ID);

  if (!popup) {
    popup = document.createElement('div');
    popup.id = POPUP_ID;
    popup.className = 'section8-notice';
    popup.style.display = 'none';
    popup.innerHTML = '<p>Sorry, we do not offer low-income or Section 8 housing.</p>';
    document.body.appendChild(popup);
  }

  return popup;
}

// Restore the choice made before Section 8, falling back to the field's default.
function resetSelect(select) {
  const { prevValue } = select.dataset;
  const fallback = [...select.options].find((option) => option.defaultSelected) || select.options[0];

  select.value = prevValue && !SECTION8_PATTERN.test(prevValue) ? prevValue : fallback.value;
  select.dispatchEvent(new Event('change', { bubbles: true }));
  select.focus();
}

export default function section8Notice() {
  // Delegated so it survives Gravity Forms AJAX re-renders.
  document.addEventListener('focusin', (e) => {
    if (e.target.matches('.gform_wrapper select')) {
      e.target.dataset.prevValue = e.target.value;
    }
  });

  document.addEventListener('change', (e) => {
    const select = e.target;

    if (!select.matches('.gform_wrapper select')) {
      return;
    }

    if (!SECTION8_PATTERN.test(select.value)) {
      select.dataset.prevValue = select.value;
      return;
    }

    getPopup();
    Fancybox.show([{ src: `#${POPUP_ID}`, type: 'inline' }], {
      dragToClose: false,
      on: {
        destroy: () => resetSelect(select),
      },
    });
  });
}
